import { urlHelper } from 'bizcap-commons-web/dist/url';
import AbstractLazyLoad from '../../../../commons/js/components/lazy-load/AbstractLazyLoad';
import { ISimulationParams } from './Types';
import { getInitialSimulationParams, Format, formatter } from './Utils';
import InterestRateDropdown from './InterestRateDropdown';

export default function () {
	new SimulatorLoader().initialize();
}

class SimulatorLoader extends AbstractLazyLoad {
	simulationParams: ISimulationParams;

	constructor() {
		super('.l-simulator-widget');
	}

	protected load(): void {
		this.simulationParams = getInitialSimulationParams();

		const interestRateDropdown = InterestRateDropdown(this.simulationParams);

		document.querySelectorAll('.l-simulator-widget input').forEach((element) => {
			element.addEventListener('change', (event) => {
				this.simulationParams[event.target.name] = parseFloat(event.target.value);

				this.simulationRender();
				interestRateDropdown.render();
			})
		});

		document.querySelector('.l-simulator-widget')?.addEventListener('submit', (event) => {
			event.preventDefault();

			const url = urlHelper(`/pedido/${location.search}`)
					.addQueryParam('loan_amount', `${this.simulationParams.amount}`)
					.addQueryParam(
							'additional_data',
							`{installment:${this.simulationParams.tenure},rate:${this.simulationParams.interestRate}}`
					)
					.toString();

			window.location.href = url;
		})

		import('../SliderInput')
			.then(({ SliderInput }) => SliderInput('.c-slider-input'));
	}

	private async simulationRender(): void {
		const { getSimulation } = await import('bizcap-commons-web/dist/loan');

		const simulation = getSimulation({
			...this.simulationParams, isSimplesNacional: false,
		});

		document.querySelectorAll('[data-simulate-result]').forEach((item: HTMLElement) => {
			if (!item.classList.contains('loaded')) {
				item.classList.add('loaded');
			}

			const value = {
				...this.simulationParams,
				...simulation,
			}[item.dataset.simulateResult];

			item.innerHTML = item.dataset.format
				? formatter(item.dataset.format as Format, value)
				: value;
		});
	}
}